import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function BillingCancel() {
  const nav = useNavigate();
  useEffect(() => { nav("/subscribe", { replace: true }); }, [nav]);
  return null;
}
